import {compose} from 'redux';
import withUsers from '../../../_common/components/Users/components/withUsers';
import withAllShumaTypes from '../../../_common/components/ShumaTypes/components/withAllShumaTypes';
import InspectionsPageFilters from './InspectionsPageFilters';

export default compose(
  withUsers,
  withAllShumaTypes
)(InspectionsPageFilters);
